import React, {useContext, useEffect, useState} from 'react';
import './UpdateUser.css'
import {useNavigate, useParams} from "react-router-dom";
import {oneUser, resetPassword, updateUser} from "../../http/UserAPI";
import {observer} from "mobx-react-lite";
import {Context} from "../../index";
import good from "../../accets/img/Good.png"

const UpdateUser = () => {

    const {id} = useParams()
    const navigate = useNavigate()
    const {userStore} = useContext(Context)

    const [oneUserDate, setOneUserDate] = useState({})
    const [nickname, setNickname] = useState('')
    const [firstName, setFirstName] = useState('')
    const [secondName, setSecondName] = useState('')
    const [role, setRole] = useState('')
    const [password, setPassword] = useState('')
    const [pass, setPass] = useState('')
    const [successPass, setSuccessPass] = useState(false)
    const [blocked, setBlocked] = useState()

    useEffect(() => {
        oneUser(id).then(data => {
            setOneUserDate(data)
            setNickname(data.nickname)
            setFirstName(data.firstName)
            setSecondName(data.secondName)
            setRole(data.role)
            setBlocked(data.block)
        })
    }, [id])

    const updateOneUserDate = {
        id: oneUserDate.id,
        nickname: nickname.toLowerCase(),
        firstName: firstName,
        secondName: secondName,
        role: role,
        block: blocked
    }

    const updateOneUserBtn = (updateOneUserDate) => {
        updateUser(updateOneUserDate)
        navigate('/job/admin_panel')
    }

    const resetPassData = {id: oneUserDate.id, password: password}

    const resetPasswordBtn = (resetPassData) => {
        resetPassword(resetPassData)
        setSuccessPass(true)
        setPassword('')
        setPass('')
        setTimeout(() => {
            setSuccessPass(false)
        }, 5000)
    }


    return (
        <div className="ml">
            <div className="task__name__block">
                <div className="title__task title__task_adm">
                    Редактирование пользователя: {oneUserDate.firstName} {oneUserDate.secondName}
                </div>

                <div className="btn__new__user__block">
                    <button className="btn__yes" onClick={() => updateOneUserBtn(updateOneUserDate)}>Сохранить</button>
                    <div className="cl-btn-6" onClick={() => navigate('/job/admin_panel')}>
                        <div className="cl-btn-6-in">
                            <div className="cl-btn-6-txt">Отмена</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="input__block">
                <div className="one__user__all__block">
                    <div className="one__user__block">
                        <h4>Логин</h4>
                        <input type="text" value={nickname} onChange={e => setNickname(e.target.value)}/>
                    </div>
                    <div className="one__user__block">
                        <h4>Фамилия</h4>
                        <input type="text" value={firstName} onChange={e => setFirstName(e.target.value)}/>
                    </div>
                    <div className="one__user__block">
                        <h4>Имя</h4>
                        <input type="text" value={secondName} onChange={e => setSecondName(e.target.value)}/>
                    </div>
                    <div className="one__user__block">
                        <h4>Роль</h4>
                        <select onChange={e => setRole(e.target.value)} value={role}
                                className="select__css">
                            {userStore.role.map(role =>
                                <option
                                    onClick={() => setRole(role)}
                                    key={role.id}
                                    value={role.id}
                                >
                                    {role.value}
                                </option>
                            )}
                        </select>
                    </div>
                    <div className="one__user__block">
                        <h4>Блокировка</h4>
                        <div className="blocked__block">
                            {blocked
                                ?
                                <div className="blocked__text">Да</div>
                                :
                                <div className="blocked__text">Нет</div>
                            }

                            <div className="blocked__check"
                                 style={
                                     {
                                         justifyContent: !blocked ? "right" : "left",
                                         background: blocked ? "red" : "white"
                                     }
                                 }
                                 onClick={() => setBlocked(!blocked)}
                            >
                                <div className="check"></div>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="one__user__all__block">
                    <h2>Сменить пароль пользователя</h2>
                    <div className="one__user__block">
                        <h4>Новый пароль</h4>
                        <input type="password" value={password} onChange={e => setPassword(e.target.value)}/>
                    </div>
                    {password.length < 6 && password !== '' ?
                        <h5>Пароль не может быть меньше шести символов</h5>
                        : null
                    }
                    <div className="one__user__block">
                        <h4>Подтверждение</h4>
                        <input type="password" value={pass} onChange={e => setPass(e.target.value)}/>
                    </div>
                    {pass !== password &&
                        <h5>Не совпадают пароли!!!</h5>
                    }
                    <div className="reset__pass__block">
                        {pass === password && password !== '' && password.length > 5 ?
                            <button className="btn__yes"
                                    onClick={() => resetPasswordBtn(resetPassData)}>Сменить</button>
                            : null
                        }

                    </div>
                    {successPass
                        ? <div className="success__pass">
                            <img src={good} alt={good}></img>
                            <div className="success__pass__title">Пароль успешно изменен</div>
                        </div>
                        : null}

                </div>
            </div>

        </div>
    );
};

export default observer(UpdateUser);